'use client';

import React from 'react';
import styled from 'styled-components';

export interface CountChipProps {
  icon: React.ReactNode;
  count: number | string;
  label?: string;
  className?: string;
}

const Pill = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 9px;
  border: 1px solid ${(p) => p.theme.colors.neutral.line};
  border-radius: ${(p) => p.theme.radius.pill};
  font-size: ${(p) => p.theme.fontSize.sm};
  font-family: ${(p) => p.theme.fontFamily.ui};
  color: ${(p) => p.theme.colors.neutral.inkSoft};
  background: ${(p) => p.theme.colors.neutral.panel};
  line-height: 1;
`;

export function CountChip({ icon, count, label, className }: CountChipProps) {
  const ariaLabel = label ? `${count} ${label}` : undefined;
  return (
    <Pill aria-label={ariaLabel} className={className}>
      {icon}
      {count}
    </Pill>
  );
}
